/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

/* eslint-disable no-invalid-this */

'use strict';

// MODULES //

import IS_LITTLE_ENDIAN from '@stdlib/assert-is-little-endian';
import Boolean from '@stdlib/boolean-ctor';
import PRIVATE_BUFFER from './private_buffer.js';


// MAIN //

/**
* Returns a function for resolving field data.
*
* @private
* @param {Object} obj - field object
* @param {string} method - data view method name
* @returns {Function} function for resolving field data
*/
function getBoolean( obj, method ) {
	return getter;

	/**
	* Reads a boolean value from an underlying byte buffer.
	*
	* @private
	* @returns {boolean} result
	*/
	function getter() {
		var view = this[ PRIVATE_BUFFER ];
		return Boolean( view[ method ]( obj.byteOffset, IS_LITTLE_ENDIAN ) );
	}
}


// EXPORTS //

export default getBoolean;
